const NorfolkIslandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112054)">
      <path
        d="M28.6953 1.98453C26.066 0.713125 23.1162 0 19.9997 0C16.8832 0 13.9335 0.713125 11.3041 1.98453L9.56494 20L11.3041 38.0155C13.9335 39.2869 16.8832 40 19.9997 40C23.1162 40 26.066 39.2869 28.6953 38.0155L30.4345 20L28.6953 1.98453Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.3044 1.98535C4.61445 5.2202 0 12.0709 0 20.0001C0 27.9293 4.61445 34.78 11.3044 38.0149V1.98535Z"
        fill="#6DA544"
      />
      <path
        d="M28.6958 1.98535V38.0149C35.3857 34.78 40.0002 27.9293 40.0002 20.0001C40.0002 12.071 35.3857 5.2202 28.6958 1.98535Z"
        fill="#6DA544"
      />
      <path
        d="M25.2176 26.0871L20.0001 9.56543L14.7827 26.0871H18.6958V30.435H21.3045V26.0871H25.2176Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112054">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default NorfolkIslandSvg;
